// extracted by mini-css-extract-plugin
export default {"payment":"PaymentStatus_payment__uNUj6","pay":"PaymentStatus_pay__3OYTp","go":"PaymentStatus_go__txoB-"};